import { render, staticRenderFns } from "./LoginAtrust.vue?vue&type=template&id=6dc0c772&scoped=true"
import script from "./LoginAtrust.vue?vue&type=script&lang=js"
export * from "./LoginAtrust.vue?vue&type=script&lang=js"
import style0 from "./LoginAtrust.vue?vue&type=style&index=0&id=6dc0c772&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0c772",
  null
  
)

export default component.exports